import { contrastRatio } from './brandPalette'
import { type Oklch, oklchToHex } from './oklch'

export type RampTheme = 'light' | 'dark'

export interface ContrastCheck {
  against: string
  floor: number
}

const NUDGE_STEP = 0.0005
const NUDGE_STEPS = 100
const NUDGE_DIRECTIONS = [1, -1] as const

export function nudgeLightness(base: Oklch, checks: readonly ContrastCheck[]): string {
  let bestHex = oklchToHex(base)
  let bestScore = Number.NEGATIVE_INFINITY
  for (let step = 0; step <= NUDGE_STEPS; step += 1) {
    for (const direction of NUDGE_DIRECTIONS) {
      if (step === 0 && direction === -1) {
        continue
      }
      const hex = oklchToHex({ l: base.l + direction * step * NUDGE_STEP, c: base.c, h: base.h })
      const score = Math.min(
        ...checks.map((check) => contrastRatio(hex, check.against) / check.floor)
      )
      if (score >= 1) {
        return hex
      }
      if (score > bestScore) {
        bestScore = score
        bestHex = hex
      }
    }
  }
  return bestHex
}
